import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button9Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M0 10H17L11.7241 5V0H5.86207V5L0 10ZM0 21H5V11H0V21ZM17 21H12V11H17V21Z" />
  </SvgIcon>
);

export default PO28Button9Icon;
